import { ReactNode } from 'react';
import { SectionState } from './useInsightsSections';

/** Placeholder blocks while a tab loads (same `bs-skel` shimmer as the Spec 078 skeleton). */
export function SectionSkeleton({ testId = 'section-skeleton' }: { testId?: string }) {
  return (
    <div className="mkt-skeleton" aria-busy="true" aria-label="Loading numbers" data-testid={testId}>
      <div className="mkt-card"><div className="bs-skel mkt-skel-line" /><div className="bs-skel mkt-skel-chart" /></div>
      <div className="mkt-card"><div className="bs-skel mkt-skel-line" /><div className="bs-skel mkt-skel-line" /><div className="bs-skel mkt-skel-line" /></div>
    </div>
  );
}

export function SectionError({ title, message, onRetry, testId = 'section-error' }: { title: string; message?: string; onRetry: () => void; testId?: string }) {
  return (
    <div className="dash-block-error" role="alert" data-testid={testId}>
      <div>
        <div className="dash-block-error__title">{title}</div>
        {message && <div className="dash-block-error__msg">{message}</div>}
      </div>
      <button type="button" className="admin-btn admin-btn-outline admin-btn-sm" onClick={onRetry}>Retry</button>
    </div>
  );
}

/** Skeleton while loading, `dash-block-error` + Retry on failure, else the section body. */
export default function SectionStatus<T>({ state, onRetry, children }: { state: SectionState<T> | undefined; onRetry: () => void; children: (data: T) => ReactNode }) {
  if (!state || state.status === 'loading') return <SectionSkeleton />;
  if (state.status === 'error') {
    const title = state.httpStatus === 503 ? 'Numbers unavailable, try again'
      : state.httpStatus === 403 ? "You don't have access to these numbers" : "Couldn't load this tab";
    return <SectionError title={title} message={state.httpStatus === 503 ? undefined : state.message} onRetry={onRetry} />;
  }
  return <>{children(state.data)}</>;
}
